
define('tpl!ui/report/layout', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function";

function program1(depth0,data) {
  
  
  return " no-border";
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <label class=\"fold pseudo-label-box\">\n        <span class=\"check-txt hide\">"
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Hide detailed report", options) : helperMissing.call(depth0, "__", "Hide detailed report", options)))
    + "</span>\n        <span class=\"check-txt show\">"
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Show detailed report", options) : helperMissing.call(depth0, "__", "Show detailed report", options)))
    + "</span>\n        <input type=\"checkbox\"/>\n        <span class=\"icon-checkbox\"></span>\n    </label>\n    ";
  return buffer;
  }

  buffer += "<div class=\"component-report";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.noBorder), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.detailsButtonVisible), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    <div class=\"content\">";
  if (helper = helpers.content) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.content); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</div>\n</div>";
  return buffer;
  });
});

